/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RefreshRemoteSessionIssuerMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RefreshRemoteSessionIssuerMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RefreshRemoteSessionIssuerMetadataSecurity = {
  option1?: RefreshRemoteSessionIssuerMetadataSecurityOption1 | undefined;
  option2?: RefreshRemoteSessionIssuerMetadataSecurityOption2 | undefined;
};

export type RefreshRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RefreshRemoteSessionIssuerMetadataSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RefreshRemoteSessionIssuerMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RefreshRemoteSessionIssuerMetadataSecurityOption1$Outbound,
    RefreshRemoteSessionIssuerMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function refreshRemoteSessionIssuerMetadataSecurityOption1ToJSON(
  refreshRemoteSessionIssuerMetadataSecurityOption1:
    RefreshRemoteSessionIssuerMetadataSecurityOption1,
): string {
  return JSON.stringify(
    RefreshRemoteSessionIssuerMetadataSecurityOption1$outboundSchema.parse(
      refreshRemoteSessionIssuerMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type RefreshRemoteSessionIssuerMetadataSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RefreshRemoteSessionIssuerMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RefreshRemoteSessionIssuerMetadataSecurityOption2$Outbound,
    RefreshRemoteSessionIssuerMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function refreshRemoteSessionIssuerMetadataSecurityOption2ToJSON(
  refreshRemoteSessionIssuerMetadataSecurityOption2:
    RefreshRemoteSessionIssuerMetadataSecurityOption2,
): string {
  return JSON.stringify(
    RefreshRemoteSessionIssuerMetadataSecurityOption2$outboundSchema.parse(
      refreshRemoteSessionIssuerMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type RefreshRemoteSessionIssuerMetadataSecurity$Outbound = {
  Option1?:
    | RefreshRemoteSessionIssuerMetadataSecurityOption1$Outbound
    | undefined;
  Option2?:
    | RefreshRemoteSessionIssuerMetadataSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const RefreshRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    RefreshRemoteSessionIssuerMetadataSecurity$Outbound,
    RefreshRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        RefreshRemoteSessionIssuerMetadataSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        RefreshRemoteSessionIssuerMetadataSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function refreshRemoteSessionIssuerMetadataSecurityToJSON(
  refreshRemoteSessionIssuerMetadataSecurity:
    RefreshRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    RefreshRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      refreshRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type RefreshRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RefreshRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    RefreshRemoteSessionIssuerMetadataRequest$Outbound,
    RefreshRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      riskIDRequestBody: RiskIDRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        riskIDRequestBody: "RiskIDRequestBody",
      });
    }),
  );

export function refreshRemoteSessionIssuerMetadataRequestToJSON(
  refreshRemoteSessionIssuerMetadataRequest:
    RefreshRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    RefreshRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      refreshRemoteSessionIssuerMetadataRequest,
    ),
  );
}
